// biome-ignore lint/style/useImportType: <explanation>
import React, { createContext, useContext, useMemo, useState } from "react";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
// import { api } from "@teachloop/backend/_generated/api";
import { auth } from "@/elements/components/utils/convex-api";
import type { Href } from "expo-router";

type AuthContextValue = {
  isReady: boolean;
  isAuthenticated: boolean;
  hasError: boolean;
  isPending: boolean;
  pendingRedirect: Href | null;
  setRedirectTarget: (pathname: Href | null) => void;
};

const AuthContext = createContext({} as AuthContextValue);

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [pendingRedirect, setPendingRedirect] = useState<Href | null>(null);

  const {
    data: isAuthenticated = false,
    isSuccess,
    isError,
    isPending,
  } = useQuery(convexQuery(auth.isAuthenticated, {}));

  const value = useMemo(
    () => ({
      isReady: isSuccess || isError,
      isAuthenticated: isSuccess && !!isAuthenticated,
      hasError: isError,
      isPending,
      pendingRedirect,
      setRedirectTarget: (pathname: Href | null) =>
        setPendingRedirect(pathname),
    }),
    [isSuccess, isAuthenticated, isError, isPending, pendingRedirect]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
